import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MemoList } from '../../modules/ComponentsLibrary/Memo';
export const Route = createFileRoute('/notes/$notesIds')({
  component: RouteComponent,
  params: z.object({
    notesIds: z.string(),
  }),
  // Phones: the note open as its own page, so Back and refresh work.
  validateSearch: z.object({
    note: z.coerce.number().positive().optional().catch(undefined),
  }),
  head(ctx) {
    return {
      meta: [{ title: 'Notes' }],
    };
  },
});

function RouteComponent() {
  const { notesIds } = Route.useParams();
  return <MemoList reportIds={notesIds} />;
}
